// tslint:disable:max-line-length
import { ProgressSpinerComponent } from './components/progress-spiner/progress-spiner.component';
import { DialogComponent, DialogOverviewComponent } from './components/dialog/dialog.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { SlideToggleComponent } from './components/slide-toggle/slide-toggle.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { LeadFormComponent } from './components/lead-form/lead-form.component';
import { SuccessPageComponent } from './components/success-page/success-page.component';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { ExpansionComponent } from './components/expansion/expansion.component';
import { ExpansionHtmlComponent } from './components/expansion-html/expansion-html.component';
import { ExpansionTabComponent } from './components/expansion-html/expansion-tab/expansion-tab.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ButtonComponent } from './components/button/button.component';
import { LinksComponent } from './components/links/links.component';
import { PopUpComponent } from './components/pop-up/pop-up.component';
import { LoginComponent } from './components/login/login.component';
import { SelectComponent } from './components/select/select.component';
import { TextboxComponent } from './components/textbox/textbox.component';
import { GeneralFormComponent } from './components/general-form/general-form.component';
import { SliderComponent } from './components/slider/slider.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MainLayoutModule } from '../main-layout/main-layout.module';
import { ChipsComponent } from './components/chips/chips.component';
import { TableComponent } from './components/table/table.component';
import { MultiSelectComponent } from './components/multi-select/multi-select.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialRoutingModule } from './material-routing.module';
import { CardComponent } from './components/card/card.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MaterialComponent } from './material.component';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrandButtonsComponent } from './components/brand-buttons/brand-buttons.component';
import { CardholdersCoreModule } from '../../shared/cardholders-core/cardholders-core.module';

@NgModule({
    declarations: [
        MaterialComponent,
        AutocompleteComponent,
        ButtonComponent,
        CardComponent,
        CheckboxComponent,
        ChipsComponent,
        DatepickerComponent,
        DialogComponent,
        ExpansionComponent,
        FormFieldComponent,
        ProgressBarComponent,
        ProgressSpinerComponent,
        RadioButtonComponent,
        SelectComponent,
        SlideToggleComponent,
        SliderComponent,
        TableComponent,
        TabsComponent,
        TooltipComponent,
        LeadFormComponent,
        SuccessPageComponent,
        TextboxComponent,
        MultiSelectComponent,
        GeneralFormComponent,
        DialogOverviewComponent,
        LinksComponent,
        LoginComponent,
        PopUpComponent,
        BrandButtonsComponent,
        ExpansionHtmlComponent,
        ExpansionTabComponent
    ],
    imports: [
        CommonModule,
        MainLayoutModule,
        MaterialRoutingModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatRadioModule,
        MatInputModule,
        MatSliderModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatPaginatorModule,
        MatExpansionModule,
        MatDialogModule,
        MatTooltipModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatTableModule,
        MatChipsModule,
        MatIconModule,
        MatSortModule,
        MatTabsModule,
        MatCardModule,
        FormsModule,
        CardholdersCoreModule
    ],
    entryComponents: [DialogOverviewComponent],
    exports: [
        MaterialComponent,
        AutocompleteComponent,
        ButtonComponent,
        CardComponent,
        CheckboxComponent,
        ChipsComponent,
        DatepickerComponent,
        DialogComponent,
        ExpansionComponent,
        FormFieldComponent,
        ProgressBarComponent,
        ProgressSpinerComponent,
        RadioButtonComponent,
        SelectComponent,
        SlideToggleComponent,
        SliderComponent,
        TableComponent,
        TabsComponent,
        TooltipComponent,
        LeadFormComponent,
        SuccessPageComponent,
        TextboxComponent,
        MultiSelectComponent,
        GeneralFormComponent,
        DialogOverviewComponent,
        LinksComponent,
        LoginComponent,
        PopUpComponent,
        BrandButtonsComponent,
        ExpansionHtmlComponent,
        ExpansionTabComponent
    ]
})
export class MaterialModule {}
